// import { animate, state, style, transition, trigger } from '@angular/animations';
import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import {
  arrowRotateAnimation,
  showMoreLessAnimation,
} from 'src/app/shared-ui/common-ui/animations';
import { CommonStandaloneModule } from 'src/app/shared/common-standalone.module';

@Component({
  selector: 'vi-collapsable-ui',
  standalone: true,
  imports: [CommonStandaloneModule, MatCardModule, MatIconModule, MatButtonModule],
  templateUrl: './collapsable-ui.component.html',
  styleUrls: ['./collapsable-ui.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  host: { class: 'vi-collapsable-ui' },
  animations: [arrowRotateAnimation, showMoreLessAnimation],
})
export class ViCollapsableUiComponent {
  @Input() isExpanded = false;
  @Input() collapsedHeight = '100px';

  get expandedState(): 'expanded' | 'collapsed' {
    return this.isExpanded ? 'expanded' : 'collapsed';
  }

  toggleExpand(): void {
    this.isExpanded = !this.isExpanded;
  }
}
